export class RestoreVolumeToEbsSnapshotRequest {
    'providerVolumeId';
    'restoreAccountId';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerVolumeId",
            "baseName": "providerVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "EbsSnapshotRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreVolumeToEbsSnapshotRequest.attributeTypeMap;
    }
    constructor() {
    }
}
